export const graphAssignation = {
    default: ['type', 'group', 'learner', 'startDate', 'dueDate'],
    learner: ['type', 'startDate', 'dueDate'],
};